module.exports = __webpack_public_path__ + "static/media/check-grey.445ccaaf.svg";